/**
 * UI service for supervision relationship mutations.
 * Delegates to admin-actions bot for server-side authorization and two-way sync.
 */
import type { MedplumClient } from '@medplum/core';
import {
  updateProviderSupervisor as updateProviderSupervisorBot,
  updateSupervisorSupervisees as updateSupervisorSuperviseesBot,
  updateRequiresCosignature as updateRequiresCosignatureBot,
} from '../adminActionsService';

export async function updateProviderSupervisor(
  medplum: MedplumClient,
  providerId: string,
  newSupervisorId: string | null,
): Promise<void> {
  await updateProviderSupervisorBot(medplum, providerId, newSupervisorId);
  // Practitioner/{id} read cache survives invalidateSearches — same as set-role / cosignature.
  medplum.invalidateAll();
}

export async function updateRequiresCosignature(
  medplum: MedplumClient,
  providerId: string,
  requiresCosignature: boolean,
): Promise<void> {
  await updateRequiresCosignatureBot(medplum, providerId, requiresCosignature);
  // Practitioner/{id} read cache survives invalidateSearches — same as set-role.
  medplum.invalidateAll();
}

export async function updateSupervisorSupervisees(
  medplum: MedplumClient,
  supervisorId: string,
  newSuperviseeIds: string[],
): Promise<void> {
  await updateSupervisorSuperviseesBot(medplum, supervisorId, newSuperviseeIds);
  medplum.invalidateAll();
}
